<template>
  <div class="lab-staff">
    <StaffContents
    :profileImg="require('../../assets/img/lab/staff/06/profile.png')"
    :profileImgSp="require('../../assets/img/lab/staff/06/profile_sp.png')"
    profileAlt="06 AYA SHIKE"
    answer01="物理化学系の研究室で、物質が光を吸収して屈折率が変化する現象について研究していました。有機系の光応答性材料、電荷捕捉材料、キラル化合物、液晶を組み合わせた時の分子集合構造の解明から、光学測定に至るまでを検討しました。材料設計によって分子間相互作用が変わり、最終的に光学特性が変わることに面白みを感じていました。"
    answer02="第一に、扱っている製品の幅が広かったことです。定年まで腰を据えて働くつもりで就職活動をしていたので、様々な分野に出会える環境の方が研究の選択肢が増え、常に刺激を受けながら働けると思いました。また、顧客の声を直接聞きながら仕事をしたいと考えていたことも理由のひとつ。クレハはシェアNo.1の製品が多いため、大手企業が顧客になっているケースが多いものの、少数精鋭なので研究員自ら顧客の声を聞いて開発ができるというところに大きな魅力を感じました。"
    answer03="電池用バインダーをメインとした各用途向けのポリフッ化ビニリデンの設計を担当。電池メーカーの環境対策に対応できるものから、10年後の実用化を目指す次世代電池などに適用可能なものまで、広くバインダーの開発に携わっています。現在では自分が主担当の案件も増え、スケールアップや生産安定性の検討、品質管理基準の策定にも携わっています。また、顧客とのコンタクトや市場調査を通して、技術動向や求められるバインダーの性能を読み取り、新しい開発の方向性も考えています。"
    answer04="設計から手掛けている次世代電池用のバインダーを製品化し、世の中に貢献すること。そのためには、自分自身で顧客の声を聞き、要望をきちんと汲み取った上で開発を進める現在のスタイルを続けていきたいですね。若手のうちから自分が先頭に立って顧客のところへ赴き、直接フィードバックをもらえる環境というのは稀だと思うので、とてもありがたいです。研究員は研究室に籠りっぱなしというイメージがあるかもしれませんが、外に出て新しい情報を取り入れることも大切だと思っています。"
    answer05="取引先が国内外問わず有名企業ばかりなので、技術の最前線で世の中への影響力の大きい開発を進められるところ。そして、そういった取引先のもとへ研究員自身が直接出向く機会が多いところ。一人ひとりの責任や裁量が大きく、やりがいを感じます。まさに少数精鋭といった感じですね。また、いわき事業所は自然に恵まれていて、休日のアクティビティには困りません。インドア派だった私がアウトドア派に転向するほどなので、かなり充実していると思います（笑）。"
    answer06="小さい子どもがいるので、一緒に散歩や公園に行くことが多いです。いわきには海も山もありますが首都圏のように混雑している場所が少ないので、子どもと遊ぶ場所には困りません。自然の中でのびのびと体を動かすことで心身ともにリフレッシュできています。また、平日に自己研鑽や親子の時間を確保するために、週末に一気に家事をしたり一週間分の食事の作り置きをしたりしています。小さなことですが平日の心の余裕にも繋がるので、仕事もポジティブな気持ちで取り組めています。"
    :imageCut01="require('../../assets/img/lab/staff/06/image01.jpg')"
    :imageCut02="require('../../assets/img/lab/staff/06/image02.jpg')"
    :imageCut01Sp="require('../../assets/img/lab/staff/06/image01_sp.jpg')"
    :imageCut02Sp="require('../../assets/img/lab/staff/06/image02_sp.jpg')"
    :schedule="require('../../assets/img/lab/staff/06/schedule.png')"
    :schedule-sp="require('../../assets/img/lab/staff/06/schedule_sp.png')"
    />
  </div>
</template>

<script>
import StaffContents from "@/components/lab/StaffContents.vue";
export default {
  name: 'staff_member',
  components: {
    StaffContents,
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>
